<!--
 * @Author: lishiqiao
 * @Date: 2022-09-07 14:45:22
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 16:58:11
-->
<template>
  <div class="page-list old-page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select @change="baseIdChange" v-model="param.params.baseId" filterable placeholder="请选择养殖场">
            <el-option :key="item.id" v-for="item in baseList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>育苗批次&nbsp;:</label>
          <el-select v-model="param.params.seedlingDataId" filterable placeholder="请选择育苗批次">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.seedlingDataId" v-for="item in seedlingDataList" :label="item.seedlingDataName"
              :value="item.seedlingDataId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖区域&nbsp;:</label>
          <el-select @change="groupIdChange" v-model="param.params.groupId" filterable placeholder="请选择养殖区域">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in groupList" :label="item.groupName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖单元&nbsp;:</label>
          <el-select v-model="param.params.boxId" filterable placeholder="请选择养殖单元">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in boxList" :label="item.boxCode" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖品类&nbsp;:</label>
          <el-select v-model="param.params.breedTypeId" filterable placeholder="请选择养殖品类">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in breedTypeList" :label="item.breedTypeName"
              :value="item.breedTypeId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" filterable placeholder="请选择养殖品种">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in breedList" :label="item.breedName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>操作日期&nbsp;:</label>
          <el-date-picker v-model="dateRange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions" @change="dateSelectChange" type="daterange" range-separator="~"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>操作类型&nbsp;:</label>
          <el-select v-model="param.params.costType" filterable placeholder="请选择操作类型">
            <el-option label="全部" value=""></el-option>
            <el-option :key="item.id" v-for="item in typeList" :label="item.operationType"
              :value="item.operationTypeId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>查询合计&nbsp;:</label>
          <el-checkbox v-model="param.params.total"></el-checkbox>
        </div>
      </div>
      <div class="page-search-btn">
        <div @click="search" class="search-btn">查询</div>
        <div @click="reSet" class="reset-btn">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span>
            <i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span>
            <i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>育苗成本统计明细表</div>
        <div>单位 : {{ tableTitle }}</div>
        <div>日期 : {{ tableDate }}</div>
        <div style="cursor: unset">
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport" style="cursor: pointer">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出
          </span>
        </div>
      </div>
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="养殖区域"></el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="seedlingDataName" label="育苗批次"></el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="boxName" label="塘口"></el-table-column>
        <el-table-column :fixed="fixedColumnList[6].fixed" :class-name="fixedColumnList[6].selected ? 'cellSelected' : ''"
          prop="costTypeName" label="操作类型"></el-table-column>
        <el-table-column :fixed="fixedColumnList[7].fixed" :class-name="fixedColumnList[7].selected ? 'cellSelected' : ''"
          prop="boxDay" label="日期"></el-table-column>
        <el-table-column label="变动成本">
          <el-table-column label="卵"><el-table-column prop="fishNumber" label="数量"></el-table-column><el-table-column
              prop="seedlingMoney" label="卵成本(元)"></el-table-column><el-table-column prop="transportation"
              label="运杂费"></el-table-column></el-table-column>
          <el-table-column label="饲料"><el-table-column prop="fodderWeight"
              label="数量(kg)"></el-table-column><el-table-column prop="fodderMoney"
              label="金额"></el-table-column></el-table-column>
          <el-table-column prop="drugMoney" label="动保"></el-table-column>
          <el-table-column prop="consumableMoney" label="低值易耗品"></el-table-column>
          <el-table-column prop="hrMoney" label="人工"></el-table-column>
          <el-table-column prop="electricMoney" label="电费"></el-table-column>
          <el-table-column prop="netMoney" label="拉网费"></el-table-column>
          <el-table-column prop="deprecitMoney" label="折旧与摊销"></el-table-column>
          <el-table-column prop="repairCost" label="修理费"></el-table-column>
          <el-table-column prop="fuelFee" label="燃料费"></el-table-column>
          <el-table-column prop="rentalFee" label="租赁费"></el-table-column>
          <el-table-column prop="publicMoney" label="其他公摊"></el-table-column>
        </el-table-column>
        <el-table-column label="定额费用">
          <el-table-column prop="oldFee" label="网箱折旧"></el-table-column>
          <el-table-column prop="adminFee" label="网箱管理费"></el-table-column>
          <el-table-column prop="seaAreaFee" label="海域费"></el-table-column>
          <el-table-column prop="rentPondFee" label="塘租"></el-table-column>
        </el-table-column>
        <el-table-column prop="costTotal" label="成本合计"></el-table-column>
      </el-table>
      <div class="uyu-pagination">
        <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
          :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="pageNo" :pageSize.sync="pageSize" :totalCount="totalCount">
        </MyPagination>
      </div>
    </div>
  </div>
</template>
  
<script>
import {
  getBaseListsByUser,
  queryBaseGroupList,
  getOrgInfoByOrgId,
  getBreedCategory,
  listDataPermissionBoxData,
  getBreedTypeList,
  getPageOfCostRecordsDetails,
  getCostOfTypeList,
  getSeedlingDataList,
} from "./ym-seedling-details-service";
import MyPagination from "@/components/pc/my-pagination.vue";
import Page from "@/utils/methods/page";
export default {
  components: { MyPagination },
  data() {
    return {
      pageNo: 1,
      pageSize: 13,
      totalCount: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      selectCostTarget: false,
      selectCostYear: "", //双向绑定的成本日期
      modelValue: "",
      date: [
        this.$moment().subtract(3, "months").add(1, "d").format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ],
      dateRange: [
        this.$moment().subtract(3, "months").add(1, "d").format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ], // 操作日期
      // 折现图显示与否
      ehcartShow: true,
      // 折现图类别切换
      ehcartActivity: true,
      PageDisplay: true,
      tableTitle: "",
      tableDate: "",
      dateSelectNum: "1",
      value: "",
      tableData: [],
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedlingDataName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxName",
          fixed: false,
          selected: false
        },
        {
          prop: "costTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxDay",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "periodId",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          boxId: "",
          breedId: "",
          startDate: this.$moment()
            .subtract(3, "months")
            .add(1, "d")
            .format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
          total: false,
          costType: "",
          breedTypeId: "",
          seedlingDataId: "",
          breedTypeClass: "egg", // fish：养成 egg：育苗
        },
      },
      exportParams: {}, // 导出参数
      baseList: [], // 养殖场data
      groupList: [], // 养殖区域data
      breedList: [], // 养殖品种数据
      boxList: [], // 品种下拉数据
      breedTypeList: [], // 养殖品类data
      seedlingDataList: [], // 育苗批次data
      typeList: [], // 操作类型
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    // 时间区间控制在当天
    // this.date = [Page.getCurrentDayDate(), Page.getCurrentDayDate()];
  },
  mounted() {
    this.tableTitle = localStorage.getItem("orgName");
    // const num = new Date(this.$moment("2022-01-20", "yyyy-MM-dd")).valueOf();
    Page.pagesTableFixed();
    // 获取养殖场
    this.getBaseList();
  },
  // 数据监听
  watch: {
    date: function (newVal) {
      if (newVal.length) {
        this.param.params.startDate = this.$moment(newVal[0]).format(
          "yyyy-MM-DD"
        );
        this.param.params.endDate = this.$moment(newVal[1]).format(
          "yyyy-MM-DD"
        );
      } else {
        this.param.params.startDate = "";
        this.param.params.endDate = "";
      }
    },
  },
  methods: {
    // 获取育苗批次列表(每次更新养殖场重新获取)
    getBatchList(baseId) {
      getSeedlingDataList(baseId)
        .then((res) => {
          if (res.code === "0000") {
            this.seedlingDataList = res.data;
            this.seedlingDataList.unshift({
              seedlingDataId: "total",
              seedlingDataName: "汇总",
            });
          }
        })
        .catch((err) => this.$message.error(err));
    },
    // 获取养殖场下所有养殖品类(每次更新养殖场重新获取)
    getBreedTypeList(baseId) {
      getBreedTypeList(baseId)
        .then((res) => {
          this.breedTypeList = res.data;
          this.breedTypeList.unshift({
            breedTypeId: "total",
            breedTypeName: "汇总",
          });
        })
        .catch((err) => this.$message.error(err));
    },
    // 时间选择器清楚时间时间
    dateSelectChange(time) {
      if (time == null) {
        this.date = [];
      }
      this.param.params.startDate = time[0];
      this.param.params.endDate = time[1];
    },
    // 监听养殖区域改变事件重新获取养殖单元
    groupIdChange(groupId) {
      this.boxList = [];
      this.param.params.boxId = "";
      if (!groupId) {
        return;
      }
      this.getPermissionList(groupId);
    },
    // 监听养殖场改变事件重新获取养殖区域和养殖品种和成本日期
    baseIdChange(event) {
      this.baseList.filter((item) => {
        if (event === item.id) {
          this.param.params.orgId = item.orgId;
        }
      });
      this.date = [];
      // 养殖场改变初始化数据
      this.param.params.groupId = "";
      this.groupList = [];
      this.param.params.breedId = "";
      this.breedList = [];
      this.param.params.boxId = "";
      this.boxList = [];
      this.param.params.breedTypeId = "";
      this.breedTypeList = [];
      this.param.params.periodId = "";
      this.seedlingDataList = [];
      this.selectCostYear = "";
      // 重新获取养殖区域
      this.getBaseGroupList(this.param.params.baseId);
      // 重新获取养殖品种
      this.getOneOrgId(this.param.params.orgId);
      // 重新获取养殖品类
      this.getBreedTypeList(this.param.params.baseId);
      // 重新获取育苗批次
      this.getBatchList(this.param.params.baseId);
      // 获取操作类型
      this.getOperationTypes();
    },
    // 获取权限下所有养殖场
    getBaseList() {
      getBaseListsByUser()
        .then((res) => {
          this.baseList = res.data;
          if (this.baseList.length) {
            this.param.params.orgId = this.baseList[0].orgId;
            this.param.params.baseId = this.baseList[0].id;
            this.getBaseGroupList(this.param.params.baseId);
            this.getOneOrgId(this.param.params.orgId);
            this.getBreedTypeList(this.param.params.baseId);
            // 获取育苗批次
            this.getBatchList(this.param.params.baseId);
            this.getOperationTypes();
            this.initPage(this.param);
          }
        })
        .catch((err) => console.log(err));
    },
    // 获取养殖场下所有养殖区域
    getBaseGroupList(baseId) {
      queryBaseGroupList(baseId)
        .then((res) => {
          this.groupList = res.data;
          this.groupList.unshift({ id: "total", groupName: "汇总" });
        })
        .catch((err) => console.log(err));
    },
    // 获取养殖区域下所有养殖单元
    getPermissionList(groupId) {
      listDataPermissionBoxData(groupId)
        .then((res) => {
          this.boxList = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 根据机构id获取顶级机构id
    getOneOrgId(orgId) {
      getOrgInfoByOrgId(orgId)
        .then((res) => {
          // 根据顶级机构id获取到顶级机构下所有养殖品种
          getBreedCategory(res.data.id).then((res) => {
            this.breedList = res.data;
            this.breedList.unshift({ id: "total", breedName: "汇总" });
          });
        })
        .catch((err) => console.log(err));
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-02 15:41:13
     * @description: 获取操作类型
     */
    getOperationTypes() {
      getCostOfTypeList().then(
        (data) => {
          if (data.code === "0000") {
            this.typeList = data.data;
            this.typeList.unshift({
              operationTypeId: "total",
              operationType: "汇总",
            });
          }
        },
        (error) => {
          console.error(error);
        }
      );
    },

    // pageSize改变
    handleSizeChange(pageSize) {
      this.param.currPage = 1;
      this.param.pageSize = pageSize;
      this.initPage(this.param);
    },
    // page改变
    handleCurrentChange(page) {
      this.param.currPage = page;
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    reSet() {
      this.dateRange = [
        this.$moment().subtract(3, "months").add(1, "d").format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ];
      this.param = {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "periodId",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          boxId: "",
          breedId: "",
          startDate: this.$moment()
            .subtract(3, "months")
            .add(1, "d")
            .format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
          total: false,
          costType: "",
          breedTypeId: "",
          seedlingDataId: "",
          breedTypeClass: "egg", // fish：养成 egg：育苗
        },
      };
      this.getBaseList();
    },
    search() {
      this.initPage(this.param);
    },
    tableRowClassName({ row }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },
    // 初始化列表
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getPageOfCostRecordsDetails(data)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.exportParams = JSON.parse(JSON.stringify(this.param));
            this.pageNo = res.data.pageNumber;
            this.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
            if (this.param.params.startDate) {
              this.tableDate =
                this.$moment(this.param.params.startDate).format(
                  "YYYY年MM月DD日"
                ) +
                "-" +
                this.$moment(this.param.params.endDate).format(
                  "YYYY年MM月DD日"
                );
            } else {
              this.tableDate = "-";
            }
          }
          setTimeout(() => {
            loading.close();
          }, 0);
        })
        .catch((err) => this.$message.error(err));
    },
    // 育苗-存塘概览报表-实时存塘量
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            titleName: "育苗成本统计明细表",
            sheetName: "列表",
            fileName: "育苗成本统计明细表",
            param: this.exportParams,
          };
          const flag = await Page.exportDatas(
            "/checkBatchDay/getCheckBatchDayExportTable",
            param
          );
        })
        .catch(() => { });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>
  
<style lang="less" scoped>
.old-page-list {
  height: calc(~"100% - 90px");
}

.el-pagination {
  margin-top: 20px;
}

.el-checkbox {
  width: 12px !important;
}
</style>